import styled from '@emotion/styled'

import { metrics } from 'component-library/__styling/settings'
import { breakpoint, calcRem } from 'component-library/__styling/style-functions'
import { perthnow } from 'component-library/__styling/themes'

export const StyledMessage = styled('div')({
    fontFamily: perthnow.fonts.serif,
    fontSize: calcRem(16),
    lineHeight: calcRem(26),
    width: `calc(100% - 40px)`,
    maxWidth: calcRem(435),
    margin: `${calcRem(metrics.perthnow.margins.lg)} auto`,

    [breakpoint('sm')]: {
        transform: 'none',
    },

    '& p': {
        margin: 0,
    },
})
